import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import { ICONS } from 'src/assets/library';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { USER_ROLES } from 'src/config/enum';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 50;
const APP_BAR_DESKTOP = 60;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  position: 'relative',
  '&::before': {
    content: '""',
    backgroundImage: 'url("/dashboard-bg.jpeg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: 0.2,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
  },
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 10,
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { user } = useSelector((state) => state.auth);
  const [open, setOpen] = useState(false);

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} />

      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <Main>
        <Outlet />
        {user.role === USER_ROLES.CUSTOMER && (
          <Box
            sx={{
              zIndex: 99,
              position: 'fixed',
              bottom: 16,
              right: {
                xs: 4,
                md: 16,
              },
            }}
          >
            <a href="https://wa.me/+243848013975" target="_blank" rel="noopener noreferrer">
              {ICONS.whatsApp}
            </a>
          </Box>
        )}
      </Main>
    </StyledRoot>
  );
}
